import { api } from "@/lib/api";

export type EmailCategory = "SERVICE" | "MARKETING";
export type EmailTarget = "single" | "bulk";

export type EmailTemplateCode = "WELCOME" | "FEEDBACK_SURVEY" | "CREATE_WITH_ME";

export interface EmailDraft {
  category: EmailCategory;
  target_type: EmailTarget;
  template_code?: EmailTemplateCode | null;
  to?: string;
  subject: string;
  title?: string;
  message: string;
  cta_label?: string;
  cta_url?: string;
}

export interface EmailPreview {
  request_id: string;
  recipient_count: number;
  category: EmailCategory;
  target_type: EmailTarget;
  subject: string;
  html: string;
  text: string;
  configured: boolean;
  template_code?: EmailTemplateCode | null;
  warnings?: string[];
  welcome_already_sent_at?: string;
}

export interface EmailTemplateInfo {
  code: EmailTemplateCode;
  category: EmailCategory;
  automation: "AUTO_SIGNUP" | "DISABLED";
  hero_url: string;
  cta_url: string | null;
  name: string;
  description: string;
  subject: string;
  title: string;
}

export interface EmailSendResult {
  request_id: string;
  status: "SENT" | "PARTIAL" | "FAILED";
  recipient_count: number;
  sent_count: number;
  failed_count: number;
}

export interface EmailLog {
  id: string;
  timestamp: string;
  category: EmailCategory;
  subject: string;
  target_type: EmailTarget;
  recipient_email?: string | null;
  recipient_count: number;
  sent_count: number;
  failed_count: number;
  status: string;
  template_code?: string | null;
  source?: "AUTO" | "MANUAL" | null;
}

export interface EmailAdminMe {
  allowed: boolean;
  email: string;
  provider: string;
  config: { resend_api_key: boolean; email_from: boolean; email_reply_to: boolean; mail_admin_email: boolean };
}

export const emailAdminMe = () => api.get<EmailAdminMe>("/admin/email/me").then((r) => r.data);
export const emailRecipientsCount = () => api.get<{ SERVICE: number; MARKETING: number }>("/admin/email/recipients-count").then((r) => r.data);
export const emailPreview = (draft: EmailDraft) => api.post<EmailPreview>("/admin/email/preview", draft).then((r) => r.data);
export const emailSend = (request_id: string) => api.post<EmailSendResult>("/admin/email/send", { request_id }).then((r) => r.data);
export const emailLogs = () => api.get<{ items: EmailLog[] }>("/admin/email/logs").then((r) => r.data.items);
export const emailTemplates = () => api.get<{ items: EmailTemplateInfo[] }>("/admin/email/templates").then((r) => r.data.items);
export const emailTemplatePreview = (code: EmailTemplateCode) => api.get<{ code: EmailTemplateCode; subject: string; html: string; warnings: string[] }>(`/admin/email/templates/${code}/preview`).then((r) => r.data);
